// ZoneLivreursScreen.jsx - View livreurs for a specific zone
import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Table, Badge, Alert, Button } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom";
import ClickBack from "../../components/buttons/ClickBack";
import { fetchZoneLivreurs } from "./dataService";

function ZoneLivreursScreen() {
  const { id } = useParams();
  const history = useHistory();
  const [zoneData, setZoneData] = useState(null);
  const [livreurs, setLivreurs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchData();
  }, [id]);

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await fetchZoneLivreurs(id);
      setZoneData(response.zone);
      setLivreurs(response.livreurs || []);
    } catch (err) {
      console.error("Error fetching zone livreurs:", err);
      setError("Erreur lors du chargement des données");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Container fluid className="p-4 text-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Chargement...</span>
        </div>
      </Container>
    );
  }

  if (error) {
    return (
      <Container fluid className="p-4">
        <Alert variant="danger">{error}</Alert>
        <Button onClick={() => history.goBack()}>Retour</Button>
      </Container>
    );
  }

  return (
    <Container fluid className="p-4">
      <Row className="mb-4">
        <Col>
          <ClickBack />
          <h2 className="mt-3">
            Livreurs de la zone : {zoneData?.name}
          </h2>
          <p className="text-muted">
            Statut de la zone : <Badge bg={zoneData?.status === "active" ? "success" : "secondary"}>{zoneData?.status || "-"}</Badge>
          </p>
        </Col>
        <Col xs="auto" className="d-flex align-items-center">
          <Button
            variant="primary"
            onClick={() => history.push(`/zones/${id}/edit`)}
          >
            Gérer les livreurs
          </Button>
        </Col>
      </Row>

      <Row>
        <Col>
          <Card>
            <Card.Header className="bg-primary text-white">
              <h5 className="mb-0">Livreurs assignés ({livreurs.length})</h5>
            </Card.Header>
            <Card.Body>
              {livreurs.length === 0 ? (
                <Alert variant="info">
                  Aucun livreur n'est assigné à cette zone.
                </Alert>
              ) : (
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Nom</th>
                      <th>Prénom</th>
                      <th>Type</th>
                      <th>Priorité</th>
                      <th>Statut</th>
                      <th>Notes</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {livreurs.map((assignment) => (
                      <tr key={assignment.id}>
                        <td>{assignment.livreur?.id}</td>
                        <td>{assignment.livreur?.nom}</td>
                        <td>{assignment.livreur?.prenom}</td>
                        <td>
                          {assignment.is_primary ? (
                            <Badge bg="primary">Principale</Badge>
                          ) : (
                            <Badge bg="secondary">Secondaire</Badge>
                          )}
                        </td>
                        <td>
                          <Badge bg="info">{assignment.priority}</Badge>
                        </td>
                        <td>
                          <Badge bg={assignment.is_active ? "success" : "danger"}>
                            {assignment.is_active ? "Active" : "Inactive"}
                          </Badge>
                        </td>
                        <td>{assignment.notes || "-"}</td>
                        <td>
                          <Button
                            variant="primary"
                            size="sm"
                            onClick={() => history.push(`/livreurs/zones/${assignment.livreur_id}/edit`)}
                          >
                            Modifier
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default ZoneLivreursScreen;
